<template>
    <section class="main">
        <div v-show="isLoading">
            <v-page-loading />
        </div>
        <div v-show="!isLoading">
            <v-page-header :title="getPageTile" />

            <div v-show="hasLoadingError">
                <div class="grid-container">
                    <p class="text-center">
                        {{ loadingError }}
                    </p>
                </div>
            </div>

            <div v-show="!hasLoadingError">
                <div class="grid-container">
                    <div class="grid-x">
                        <div class="cell medium-9 medium-offset-1 large-11 large-offset-0">
                            <div class="wrapper">
                                <v-action-buttons :items="getActionButtons" />

                                <div class="box">
                                    <v-navigation />

                                    <div class="grid-x align-center">
                                        <div class="cell small-6">
                                            <h2>{{ $t('customers.info') }}</h2>
                                            <div class="content">
                                                <div class="content__item">
                                                    <p><strong>{{ customerObject.headquarter.company_name }}</strong></p>
                                                    <p>{{ $t('customers.client_number') }}: {{ customerObject.client_number }}</p>
                                                    <p>{{ $t('form.phone') }}: {{ customerObject.headquarter.phone }}</p>
                                                </div>
                                                <div class="content__item">
                                                    <template v-if="customerObject.contact_person">
                                                        <p>{{ $t('customers.contact_person') }}:</p>
                                                        <p>{{ customerObject.contact_person }}</p>
                                                    </template>
                                                    <p>{{ customerObject.headquarter.email }}</p>
                                                </div>
                                                <div class="content__item">
                                                    <p>{{ customerObject.headquarter.address1 }}</p>
                                                    <p>{{ customerObject.headquarter.address2 }}</p>
                                                    <p>{{ customerObject.headquarter.zipcode }} {{ customerObject.headquarter.city }}</p>
                                                    <p>{{ $helpers.countries[customerObject.headquarter.country_code] }}</p>
                                                </div>
                                                <template v-if="$store.getters.userIsAdmin">
                                                    <div class="content__item">
                                                        <div v-if="customerObject.headquarter.risk" class="content__item">
                                                            <p v-if="!customerObject.headquarter.risk.is_valid" class="u-color--alert">
                                                                <strong>{{$t('location.risk.not_valid')}}</strong>
                                                            </p>
                                                            <p><strong>{{$t('location.risk.risk_number')}}: {{customerObject.headquarter.risk.risk_number}}</strong></p>
                                                            <p v-if="customerObject.headquarter.risk.decided_budget">{{$t('location.risk.decided_budget')}}: {{$helpers.formateCurrency(customerObject.headquarter.risk.decided_budget)}}</p>
                                                            <p v-else class="u-color--alert">
                                                              {{$t('location.risk.decided_budget.not_exist')}}
                                                            </p>
                                                            <p v-if="customerObject.headquarter.risk.valid_from">{{$t('location.risk.valid_from')}}: {{customerObject.headquarter.risk.valid_from | moment('DD.MM.YYYY')}}</p>
                                                            <p v-if="customerObject.headquarter.risk.valid_until">{{$t('location.risk.valid_until')}}: {{customerObject.headquarter.risk.valid_until | moment('DD.MM.YYYY')}}</p>
                                                        </div>
                                                        <div class="content__item" v-if="locationsWithRiskWarnings()">
                                                            <p v-if="locationsWithoutRiskExists()" class="u-color--alert">{{$t('location.risk.some.locations.without.risk')}}</p>
                                                            <p v-if="locationsWithoutBudgetExist()" class="u-color--alert">{{$t('location.risk.decided_budget.not_exist')}}</p>
                                                        </div>
                                                    </div>
                                                </template>
                                            </div>
                                        </div>
                                        <div class="cell small-6 large-8 xxlarge-6">
                                            <div class="grid-x align-middle">
                                                <div class="cell shrink">
                                                    <div class="graphic graphic--circle show-for-xxlarge">
                                                        <canvas id="graphic__doughnut" height="272"></canvas>
                                                    </div>
                                                </div>
                                                <div class="cell auto">
                                                    <div class="data__numbers data__numbers--center">
                                                        <div data-static>
                                                            <span :data-static-number="projectsGrapInformation.open">{{ projectsGrapInformation.open }}</span>
                                                            <span class="is-bold">{{ $t('customers.projects_open') }}</span>
                                                        </div>
                                                        <div data-static>
                                                            <span :data-static-number="projectsGrapInformation.busy" class="u-color--orange">{{ projectsGrapInformation.busy }}</span>
                                                            <span class="is-bold">{{ $t('customers.projects_partly_done') }}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import PageHeader from './../partials/PageHeader';
    import PageLoading from './../partials/PageLoading';
    import ActionButtons from './../partials/Foundation/ActionButtons';
    import Navigation from './Navigation';

    export default {
        data() {
            return {
                loading                 : false,
                loadingError            : null,
                customerObject          : {
                    id                      : 0,
                    client_number           : '',
                    company_name            : '',
                    contact_person          : '',
                    headquarter             : {},
                    project_number_required : ''
                },
                locations : [],
                projectsGrapInformation : {
                    open                    : 0,
                    busy                    : 0,
                    finished                : 0
                },
            };
        },
        components : {
            vPageHeader             : PageHeader,
            vPageLoading            : PageLoading,
            vActionButtons          : ActionButtons,
            vNavigation             : Navigation,
        },
        computed : {

            isLoading : function () {
                return this.loading;
            },
            hasLoadingError : function () {
                return this.loadingError !== null;
            },
            getPageTile : function () {
                if (this.customerObject.company_name) {
                    return this.customerObject.company_name;
                }

                return this.$t('project.view.title');
            },
            getActionButtons : function () {
                let buttons = [];

                if (this.$store.getters.userHasPermission('customer_update')) {
                    buttons.push({
                        action  : 'update',
                        router  : { name : 'customers-update-customer', params : { customer : this.$route.params.customer } }
                    });
                }

                if (this.$store.getters.userHasPermission('project_create')) {
                    buttons.push({
                        action  : 'create-new',
                        title   : this.$t('project.create_quick.title'),
                        router  : { name : 'customers-create-customer-project', params : { custumor : this.$route.params.customer } }
                    });
                }

                return buttons;
            }
        },
        created : function () {
            this.onUpdateCustomer();
            this.getLocations();
        },
        methods : {
            locationsWithoutRiskExists: function () {
                let locationWithoutRisk = false;
                this.locations.forEach(function (location) {
                  if (typeof location.risk === undefined ) {
                    locationWithoutRisk = true;
                  }
                });

                return locationWithoutRisk;
            },
            locationsWithoutBudgetExist: function () {

              let locationWithoutBudget = false;
              this.locations.forEach(function (location) {
                if (typeof location.risk === "undefined") {
                  return locationWithoutBudget;
                }
                if (!location.risk.decided_budget) {
                  locationWithoutBudget = true
                }
              });

              return locationWithoutBudget;
            },
            locationsWithRiskWarnings: function () {
              if (this.locations.length > 1 ) {
                return this.locationsWithoutRiskExists() || this.locationsWithoutBudgetExist();
              }
              return false;
            },
            onUpdateCustomer : function () {
                this.loadingError = null;

                let promise = this.$api.clearParams()
                    .get('customers/' + this.$route.params.customer + '/get');

                promise.then((response => {
                    this.customerObject = response.data.data;

                    this.onUpdateProjectsGraph();
                    this.onUpdatePmsTableItems(true);
                }).bind(this)).catch((error => {
                    this.loadingError = error.response.data.message;
                }).bind(this)).finally((() => {
                    this.loading = false;
                }).bind(this));

                this.loading = true;
            },
            getLocations: function () {
                let promise = this.$api.clearParams()
                  .addParam('show_all', 0)
                  .addParam('customer', this.$route.params.customer)
                  .setPageParams(1, 30)
                  .get('locations');

                promise.then((response => {
                    this.locations  = response.data.data;

                    this.locationsLoading = false;
                }).bind(this)).catch((error => {
                    this.locations = [];
                    this.locationsLoading = false;
                }).bind(this));
            },
            onUpdateProjectsGraph : function () {
                let element = document.getElementById('graphic__doughnut');

                if (element) {
                    let promise = this.$api.clearParams()
                        .addParam('customer_id', this.$route.params.customer)
                        .get('projects');

                    promise.then((response => {
                        response.data.data.forEach((function (row) {
                            if (row.status === 'open') {
                                this.projectsGrapInformation.open++;
                            } else if (row.status === 'busy') {
                                this.projectsGrapInformation.busy++;
                            } else if (row.status === 'finished') {
                                this.projectsGrapInformation.finished++;
                            }
                        }).bind(this));

                        var chart = new Chart(element.getContext('2d'), {
                            type        : 'doughnut',
                            data        : {
                                datasets    : [{
                                    data        : [this.projectsGrapInformation.open, this.projectsGrapInformation.busy],
                                    backgroundColor : ['#BD0D30', '#FFB100'],
                                    borderWidth : 0
                                }],
                                labels      : ['offene Aufträge', 'Aufträge teilerledigt']
                            },
                            options     : {
                                segmentShowStroke : false,
                                responsive  : true,
                                legend      : {
                                    display     : false
                                },
                                title       : {
                                    display     : false
                                },
                                animation   : {
                                    animateScale    : true,
                                    animateRotate   : true
                                }
                            }
                        });
                    }).bind(this));
                }
            }
        }
    }
</script>